import { useState } from 'react';
import styled from 'styled-components';
import ImminentItem from './ImminentItem';
import SampleCard from './SampleCard';
import { Imminent, Sample } from './types';

type SampleTab = 'auction' | 'pAuction' | 'npl';
interface SampleLists {
  auction: Sample[];
  pAuction: Sample[];
  npl: Sample[];
}

interface Props {
  imminentList: Imminent[];
  sampleList: SampleLists;
}

const ItemAndSample = ({ imminentList, sampleList }: Props) => {
  const [sampleTab, setSampleTab] = useState<SampleTab>('auction');
  const currentList = sampleList?.[sampleTab] ?? [];

  return (
    <Container>
      <Section>
        <SectionTitle>매각 임박 물건 소개</SectionTitle>
        <ImminentItemList>
          {imminentList &&
            imminentList
              .slice(0, 4)
              .map((item) => <ImminentItem key={item.iidx} item={item} />)}
        </ImminentItemList>
      </Section>
      <SampleSection>
        <SectionTitle>샘플 물건</SectionTitle>
        <SampleTabBox>
          <SampleTabButton
            onClick={() => setSampleTab('auction')}
            isActive={sampleTab === 'auction'}
          >
            경매샘플
          </SampleTabButton>
          <SampleTabButton
            isActive={sampleTab === 'pAuction'}
            onClick={() => setSampleTab('pAuction')}
          >
            공매샘플
          </SampleTabButton>
          <SampleTabButton
            isActive={sampleTab === 'npl'}
            onClick={() => setSampleTab('npl')}
          >
            NPL샘플
          </SampleTabButton>
        </SampleTabBox>
        <SampleList>
          {currentList.map((item) => (
            <SampleCard key={item.iidx} item={item} />
          ))}
        </SampleList>
      </SampleSection>
    </Container>
  );
};

export default ItemAndSample;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
`;

const Section = styled.div`
  display: flex;
  padding: 24px 0 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  background: #fff;
`;

const SampleSection = styled(Section)`
  border-radius: 0;
`;

const SectionTitle = styled.div`
  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ImminentItemList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 24px;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-right: 16px;
`;

interface ISampleProps {
  isActive: boolean;
}

const SampleTabButton = styled.div<ISampleProps>`
  display: flex;
  flex-direction: row;

  font-size: 13px;
  font-weight: 500;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 9999px;
  padding: 8px 16px;
  color: ${(props) => (props.isActive ? '#fff' : '#989ba2')};
  background: ${(props) =>
    props.isActive ? '#222' : 'rgba(112, 115, 124, 0.08)'};
`;

const SampleTabBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const SampleList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  scrollbar-width: thin;
  padding-right: 16px;
`;
